<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <div>
      <h1 class="px-4 fade-in-up-enter-active animation-slowest max-100 text-primary">WOZ-waarde woning</h1>
      <!-- <h4 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200">2025</h4> -->
      <base-form @submit="onSubmit">
        <div class="d-flex flex-column flex-lg-row justify-content-center">
            <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
                <!-- Info-balkje -->
                <base-card class="mb-4" inner-class="small" color="secondary">
                    <h6 class="mb-2">Waar vind ik de WOZ-waarde?</h6>
                    <ul class="mb-0">
                        <li>De WOZ-waarde staat op de jaarlijkse beschikking van uw gemeente.</li>
                        <li>U kunt de WOZ-waarde ook vinden via <a :href="wozUrl" target="_blank" rel="noopener">wozwaardeloket.nl</a>.</li>
                      <li v-if="wozPeiljaar">Let op: vul de WOZ-waarde in van <strong>peiljaar {{ wozPeiljaar }}</strong>.</li>
                    </ul>
                </base-card>
                <!-- Vraag en invoer -->
                <base-input
                name="WOZWaarde"
                type="number"
                min="0"
                step="1000"
                placeholder="Bijvoorbeeld 250000"
                :value="lead.otherSubsidies.woz.woz_waarde_volgens_bewoner"
                @update:value="onWozValueUpdate"
                >
                {{ wozQuestion }}
                </base-input>

            </base-card>
        </div>
        <button-row class="mt-4 flex-row-reverse">
            <base-button class="ms-auto" icon="bi-arrow-right" type="submit" :disabled="this.v$.otherSubsidies.woz.$invalid">Volgende</base-button>
            <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
        </button-row>
        </base-form>
    </div>
  </interview-layout>
</template>

<script>
import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
import BaseCard from "@/components/BaseCard.vue";
import BaseButton from "@/components/BaseButton.vue";
import BaseInput from "@/components/BaseInput.vue";
import ButtonRow from "@/components/ButtonRow.vue";


import { useAllStores } from "@/helpers/UseAllStores";
import { FlowService } from "@/services/FlowService";
import { MunicipalitySubsidyService } from "@/services/MunicipalitySubsidyService";
import BaseForm from "@/components/BaseForm.vue";

export default {
  components: {
    InterviewLayout,
        BaseCard,
    BaseForm,
    BaseButton,
    BaseInput,
    ButtonRow,
  },
  setup() {
    return { ...useAllStores() };
  },
  data() {
    return {};
  },
  computed: {
    wozUrl() {
      const postcode = String(this.lead?.address?.PostalCode || "").replace(/\s+/g, "").toUpperCase();
      const number = String(this.lead?.address?.StreetNumber || "").trim();
      const letter = String(this.lead?.address?.Street_number_letter__c || "").trim();
      let suffix = String(this.lead?.address?.Street_number_addition__c || "").trim();

      if (!postcode || !number) {
        return "https://www.wozwaardeloket.nl/";
      }

      if (suffix && !suffix.startsWith("-")) {
        suffix = `-${suffix}`;
      }

      const house = `${number}${letter}${suffix}`;
      return `https://www.wozwaardeloket.nl/index.jsp?locatie=${encodeURIComponent(postcode)}+${encodeURIComponent(house)}`;
    },
    wozPeiljaar() {
      return MunicipalitySubsidyService.getWozPeiljaar(this.lead.address?.pc_GemNaam);
    },
    wozQuestion() {
      return MunicipalitySubsidyService.getLabel(this.lead.address?.pc_GemNaam, "woz");
    },
  },
  methods: {
    touchAndValidate() {
      this.v$.otherSubsidies.woz.$touch();
            return !this.v$.otherSubsidies.woz.$invalid;
    },
    onSubmit() {
      if (this.touchAndValidate()) {
        FlowService.pushNext(this);
      }
    },
    onWozValueUpdate(value) {
      if (typeof value !== "string") {
        this.lead.otherSubsidies.woz.woz_waarde_volgens_bewoner = value;
        return;
      }

      const normalizedValue = value.trim().replace(/\s/g, "");
      const isThousandsFormatted = /^\d{1,3}(?:[.,]\d{3})+$/.test(normalizedValue);

      this.lead.otherSubsidies.woz.woz_waarde_volgens_bewoner = isThousandsFormatted
        ? normalizedValue.replace(/[.,]/g, "")
        : normalizedValue;
    },
    onPrev() {
      FlowService.pushPrev(this);
    },
  },
  mounted() {
    
  },
};
</script>

<style scoped lang="scss">

</style>
